import script from "./LigatureComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./LigatureComponent.vue?vue&type=script&setup=true&lang=js"

import "./LigatureComponent.vue?vue&type=style&index=0&id=77a22d94&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77a22d94"]])

export default __exports__